import { useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledMultipleAutocomplete } from 'components/common/controller-wrapper'
import { useGetBidSpreadAnalysisServiceCodesQuery } from 'generated/graphql'

import { BidSpreadAnalysisFilterValues } from './BidSpreadAnalysisFilterCriteria'
import { useBidSpreadAnalysisQueryInput } from './useBidSpreadAnalysisQueryInput'

export const BidSpreadAnalysisServiceCodeMultipleAutocomplete = () => {
  const { control } = useFormContext<BidSpreadAnalysisFilterValues>()
  const { start, end } = useBidSpreadAnalysisQueryInput()

  const { data } = useGetBidSpreadAnalysisServiceCodesQuery({
    variables: { input: { start, end } },
    skip: start == null || end == null,
  })

  const serviceCodes = useMemo(
    () =>
      [...(data?.bidSpreadAnalysisServiceCodes ?? [])]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((code) => ({ value: code.id, label: code.name })),
    [data],
  )

  return (
    <ControlledMultipleAutocomplete
      control={control}
      name='selectedServiceCodes'
      label='Service code'
      options={serviceCodes}
      defaultValue={[]}
      limitTags={3}
      size='small'
      sx={{ minWidth: 220 }}
      noOptionsText='No service codes available in the selected period'
    />
  )
}
